import * as types from './actionTypes';
import { getRequest, postRequest } from '../../lib/apiUtils';
import { clearRecipientSummaryCache } from '../../lib/recipientSummaryCache';

async function getVerificationToken() {
    return await getRequest("/xsrfToken");
}

export function login(username, password) {
    return async dispatch => {
        dispatch({ type: types.START_LOGIN });

        let response = { loading: false, success: false, data: {} };

        const verification = await getVerificationToken();
        response.success = verification.success;

        if (verification.success) {
            const login = await postRequest('/account/login', { username, password }, { [verification.data.tokenName]: verification.data.token });

            response.success = login.success;
            response.message = !login.success ? (login.message || "Sorry, something went wrong.  Please try again.") : "";
            response.data = login.data || {};
            if (login.success) clearRecipientSummaryCache();

            if (login.success && !login.data.verify) {
                const lastVerification = await getVerificationToken();
                response.success = lastVerification.success;
                if (response.success) {
                    localStorage.setItem("RequestVerificationToken", lastVerification.data.token);
                }
            }
        }

        dispatch({ type: types.LOGIN, response });
    }
}

export function verifyLogin(verificationCode, remember) {
    return async dispatch => {
        dispatch({ type: types.START_VERIFY_LOGIN });

        let response = { loading: false, success: false };

        const verification = await getVerificationToken();
        response.success = verification.success;

        if (verification.success) {
            const verifyLogin = await postRequest(`/account/verify?verificationCode=${verificationCode}&remember=${remember}`, null, { [verification.data.tokenName]: verification.data.token });

            response.success = verifyLogin.success;
            response.message = !verifyLogin.success ? (verifyLogin.message || "Sorry, something went wrong.  Please try again.") : "";

            if (verifyLogin.success) {
                clearRecipientSummaryCache();
                const lastVerification = await getVerificationToken();
                response.success = lastVerification.success;
                if (response.success) {
                    localStorage.setItem("RequestVerificationToken", lastVerification.data.token);
                }
            }
        }

        dispatch({ type: types.VERIFY_LOGIN, response });
    }
}

export function logout() {
    return async dispatch => {
        dispatch({ type: types.START_LOGOUT });

        const response = await postRequest("/account/logout");

        dispatch({ type: types.LOGOUT, response });

        if (response.success) {
            clearRecipientSummaryCache();
            localStorage.removeItem("RequestVerificationToken");
            localStorage.removeItem("IdleTimer");
            dispatch({ type: types.LOGOUT_SUCCESS });
        }
    }
}

export function recoverPassword(email) {
    return async dispatch => {
        dispatch({ type: types.START_RECOVER_PASSWORD });

        let response = { loading: false, success: false };

        const verification = await getVerificationToken();
        response.success = verification.success;

        if (verification.success) {
            const recover = await postRequest('/account/forgotPassword', { url: `${window.location.origin}/reset-password`, email },
                { [verification.data.tokenName]: verification.data.token });
            response.success = recover.success;
        }

        dispatch({ type: types.RECOVER_PASSWORD, response });
    }
}

export function resetPassword(token, newPassword) {
    return async dispatch => {
        dispatch({ type: types.START_RESET_PASSWORD });

        let response = { loading: false, success: false };

        const verification = await getVerificationToken();
        response.success = verification.success;

        if (verification.success) {
            const reset = await postRequest('/account/resetPassword', { url: `${window.location.origin}/recover-password`, token, newPassword },
                { [verification.data.tokenName]: verification.data.token });
            response.success = reset.success;
            response.expired = !reset.success ? (reset.message && reset.message.toLowerCase().indexOf('expired')) === 0 : false;
        }

        dispatch({ type: types.RESET_PASSWORD, response });
    }
}

export function externalLogin(token) {
    return async dispatch => {
        dispatch({ type: types.START_LOGIN });

        let response = { loading: false, success: false };

        const verification = await getVerificationToken();
        response.success = verification.success;

        if (verification.success) {
            const login = await postRequest(`/account/externalLogin?token=${token}`, null, { [verification.data.tokenName]: verification.data.token });
            response.success = login.success;

            if (login.success) {
                clearRecipientSummaryCache();
                const lastVerification = await getVerificationToken();
                response.success = lastVerification.success;
                if (response.success) {
                    localStorage.setItem("RequestVerificationToken", lastVerification.data.token);
                }
            }
        }

        dispatch({ type: types.LOGIN, response });
    }
}


// WEBPACK FOOTER //
// ./src/redux/actions/AuthenticationActions.js